import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PartnerDigital } from 'Pages/smsExpansion'
import { Callback } from 'Src/types/utilTypes'

export namespace PartnerNS {
	export type UpdatePartner = PayloadAction<{
		id: number
		data: PartnerDigital
		callback?: Callback
	}>
}

export const partnerSlice = createSlice({
	name: 'partner_neo',
	initialState: {},
	reducers: {
		updatePartner: (state, action: PartnerNS.UpdatePartner) => {},
	},
})
